import { render, staticRenderFns } from "./DashboardPermitType.vue?vue&type=template&id=78e565e1&"
import script from "./DashboardPermitType.vue?vue&type=script&lang=js&"
export * from "./DashboardPermitType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports